export default "__VITE_ASSET__D7jwwF$9__"